import React from 'react'
import { Button } from '@deal/components'
import Instagram from './instagram.svg'
import styles from './styles.css'

interface FollowMeProps {
  instagramUrl: string
  className?: string
}

const FollowMe: React.SFC<FollowMeProps> = ({ instagramUrl, className }) => {
  return (
    <a href={instagramUrl} target="_blank" className={className}>
      <Button variant="link" className={styles.follow} size="small">
        <Instagram className={styles.icon} /> <span className={styles.followLabel}>Follow me</span>
      </Button>
    </a>
  )
}

export default FollowMe
